// /**
//  * web-hook - List
//  */

// React
import React, {useEffect, useState} from 'react';

// UI
import theme from '../../theme';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

// Type
import {SelectorProps, Props} from './interfaces';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';

import {Link, useHistory} from 'react-router-dom';
import {Payload} from './interfaces';
import WebhookComponent from './webhook';

import {
  makeSelectCountList,
  makeSelectList,
  makeSelectError,
  makeSelectLoading,
} from './selectors';
import {getWebhooksAction} from './actions';
import Pagination from '@material-ui/lab/Pagination';
import useQuery from '../../utils/hook/useQuery';
import RonadIcons from '../../components/iconComponent';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Inputs = {
  description: string;
  reason: string;
  amount: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    cardContentOrder: {
      padding: '0',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginTop: '24px',
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
  })
);

function Index(props: Props) {
  const classes = useStyles();
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const getWebhooks = () => {
    const {page, size} = filtersValues;
    props.webhooksDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  useEffect(() => {
    getWebhooks();
  }, [filtersValues]);

  return (
    <>
      <Typography variant="h6" component="h2">
        {`مدیریت وب هوک`}
      </Typography>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item></Grid>
      </Grid>
      <form style={{display: 'flex'}}>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Grid>
                <Typography className={classes.typographyCards}>
                  لیست وب‌هوک‌ها
                </Typography>
              </Grid>
            }
            action={
              <div className={classes.btnBox}>
                <Link to="/webhooks/create" style={{textDecoration: 'none'}}>
                  <Button
                    type="button"
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    startIcon={<RonadIcons name='plus' className='text-white' size={0.7}/>}
                  >
                    {'ایجاد وب هوک'}
                  </Button>
                </Link>
              </div>
            }
          />

          <CardContent className={classes.cardContentOrder}>
            {props.webhooksList[0] ? (
              <>
                <Grid
                  style={{padding: '30px 20px', marginTop: '10px'}}
                  xs={12}
                  container
                  spacing={2}
                  alignItems="flex-start"
                >
                  {props.loading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {props.webhooksList.map((webhook: any) => {
                        return <WebhookComponent webhook={webhook} />;
                      })}
                    </>
                  )}
                </Grid>
                <Grid
                  id="showFilter"
                  style={{padding: '20px 40px'}}
                  item
                  xs={12}
                  sm={6}
                >
                  {props.webhooksList && (
                    <FormControl
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                        {' '}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleCloseSelect}
                        className={classes.showCount}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid xs={12} sm={6} container item direction="row-reverse">
                  {props.webhooksList && (
                    <Pagination
                      count={Math.ceil(props.count / filtersValues.size)}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </>
            ) : (
              <Typography style={{padding: '50px', fontSize: '32px'}}>
                شما وب‌هوکی ایجاد نکرده‌اید
              </Typography>
            )}
          </CardContent>
        </Card>
      </form>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  webhooksList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    webhooksDispatch: (payload: Payload) =>
      dispatch(getWebhooksAction(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Index);
